import React, { useEffect,useState } from "react";
import { Sparkle} from "lucide-react";


// import adhd from "../assets/tracks/adhd.jpg"
import mental_health_nursing from "../assets/tracks/mental_health_nursing.jpg"
import infection_control from "../assets/tracks/infection_control_prevention.jpg"
import pallative_care from "../assets/tracks/pallative_care.jpg"
import Painmanagement from "../assets/tracks/pain_management.jpg"
import neurodiversity from "../assets/tracks/neurodiversity.jpg"
import autism from "../assets/tracks/Autism.jpg"
import critical_care_nursing from "../assets/tracks/critical_care_nursing.jpg"
import genetic_disorder from "../assets/tracks/genetic_disorder.jpg"
import geriatric_nursing from "../assets/tracks/geriatric_nursing.jpg"
import epidemiology from "../assets/tracks/epidemiology.jpg"
import chronic_disease_management from "../assets/tracks/chronic_disease_management.jpg"
import community_nursing from "../assets/tracks/community_nursing.jpg"
import adhd from "../assets/tracks/emergency_trauma_nursing.jpg"


const tracks = [
  {
    image: mental_health_nursing,
    title: "Mental Health Nursing",
    subtitle: "Compassionate Care for Mental Wellness",
    description:
      "Mental health nursing focuses on providing care to individuals with mental health disorders, such as depression, anxiety, schizophrenia, and substance abuse issues. Nurses collaborate with psychiatrists and other professionals to create personalized care plans aimed at promoting recovery and managing symptoms. They offer therapeutic support, assist with treatment adherence, and provide education to patients and their families.",
  },
  {
    image: infection_control,
    title: "Infection Control & Prevention",
    subtitle: "Safeguarding Healthcare Through Prevention",
    description:
      "Infection control and prevention in healthcare focuses on reducing the spread of infectious diseases by implementing strategies to prevent healthcare-associated infections (HAIs). Key measures include proper hand hygiene, use of PPE, sterilization of instruments, and patient isolation. It also involves outbreak monitoring, staff education, and maintaining a clean environment.",
  },
  {
    image: pallative_care,
    title: "Palliative Care",
    subtitle: "Improving Quality of Life Through Comfort-Centered Care",
    description:
      "Palliative care focuses on relieving symptoms, pain, and stress from serious illnesses, prioritizing quality of life over curative treatments. It addresses physical, emotional, and spiritual well-being, and is provided alongside curative care at any stage of illness, emphasizing dignity and support for both patients and families.",
  },
  {
    image: Painmanagement,
    title: "Pediatric Nursing",
    subtitle: "Holistic Care for Children and Adolescents",
    description:
      "Pediatric nursing focuses on providing care to infants, children, and adolescents, addressing their unique medical, emotional, and developmental needs. Pediatric nurses play a key role in preventing, diagnosing, and treating illnesses, and promoting preventive care while educating and supporting families.",
  },
  {
    image: neurodiversity,
    title: "Neurodiversity",
    subtitle: "Embracing Cognitive Differences in Healthcare",
    description:
      "Neurodiversity recognizes and respects neurological differences such as autism, ADHD, and dyslexia as natural variations of the human brain. In healthcare, this perspective promotes inclusive care, personalized interventions, and the celebration of unique strengths and abilities of neurodivergent individuals.",
  },
  {
    image: autism,
    title: "Autism",
    subtitle: "Understanding and Supporting Autism Spectrum Disorder",
    description:
      "Autism Spectrum Disorder (ASD) is characterized by challenges in social interaction, communication, and behavior. Symptoms vary widely in severity. Early diagnosis and intervention are crucial for improving outcomes. Healthcare providers play a key role in supporting development and quality of life for individuals with autism.",
  },
  {
    image: critical_care_nursing,
    title: "Critical Care Nursing",
    subtitle: "Lifesaving Expertise in Critical Environments",
    description:
      "Critical care nursing involves specialized care for patients with life-threatening conditions, typically in ICUs. Nurses monitor vital signs, manage complex equipment, and work with healthcare teams to stabilize patients. They are skilled in emergency response, treatment delivery, and patient recovery support.",
  },
  {
    image: genetic_disorder,
    title: "Genetic Disorders",
    subtitle: "Understanding Inherited Health Conditions",
    description:
      "Genetic disorders result from DNA mutations and can affect physical and mental health. Conditions such as cystic fibrosis, sickle cell anemia, and Down syndrome require early diagnosis, genetic counseling, and multidisciplinary care to manage symptoms and improve quality of life.",
  },
  {
    image: geriatric_nursing,
    title: "Geriatric Nursing",
    subtitle: "Comprehensive Care for the Aging Population",
    description:
      "Geriatric nursing focuses on the unique needs of older adults, managing chronic conditions, and promoting healthy aging. Nurses advocate for patient independence and dignity, addressing conditions like dementia, arthritis, and heart disease across hospitals, nursing homes, and home care settings.",
  },
  {
    image: epidemiology,
    title: "Epidemiology",
    subtitle: "Tracking and Preventing Disease Spread",
    description:
      "Epidemiology is the study of how diseases affect populations. Epidemiologists identify risk factors and develop prevention strategies by analyzing patterns and causes of health issues. Their work is vital for public health initiatives, outbreak control, and disease surveillance.",
  },
  {
    image: chronic_disease_management,
    title: "Chronic Disease Management",
    subtitle: "Sustained Support for Long-Term Conditions",
    description:
      "Chronic disease management involves ongoing care for conditions like diabetes, heart disease, and hypertension. It includes lifestyle guidance, regular monitoring, and personalized care plans, empowering patients to actively manage their health and improve long-term outcomes.",
  },
  {
    image: community_nursing,
    title: "Community Nursing",
    subtitle: "Health Promotion Within Communities",
    description:
      "Community nursing delivers healthcare in diverse community settings, focusing on health promotion, disease prevention, and chronic condition management. Nurses work in schools, clinics, and homes to provide accessible care and address public health issues through education and outreach.",
  },
  {
    image: adhd,
    title: "Nursing Informatics",
    subtitle: "Integrating Technology for Better Care",
    description:
      "Nursing informatics combines nursing science with technology to improve patient outcomes. It involves managing electronic health records (EHRs), data analysis, and optimizing clinical workflows. Informatics specialists also train staff and support the development of evidence-based protocols.",
  }
];


const StaticTracks = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <style>{`
        @keyframes pulseShadow {
          0%, 100% {
            box-shadow: 0 0 0px rgba(255, 0, 102, 0.2);
          }
          50% {
            box-shadow: 0 0 18px 6px #005B96;
          }
        }

        .animate-pulseShadow {
          animation: pulseShadow 3s ease-in-out infinite;
        }

        .transition-custom {
          transition: all 0.8s ease-in-out;
        }
      `}</style>

      <div className="relative mt-14">
        {/* Fixed Top-Right Button */}
        <div
          className="fixed top-[22%] right-[1%] z-50 transition-custom"
        >
          <a
            href="/abstract-submission"
            aria-label="Submit abstract"
            className="bg-one rounded-full text-white text-sm font-medium px-3 py-3 select-none transition-transform hover:scale-110 animate-pulseShadow"
          >
            Submit Abstract
          </a>
        </div>

        {/* Track Content */}
        <div className="container mx-auto px-4 py-10 space-y-20 flex flex-col items-center">
          {tracks.map((track, index) => (
            <div
              key={index}
              className="relative w-[80%] flex flex-col md:flex-row items-stretch md:space-x-6"
            >
              <div className="flex-shrink-0 bg-white border shadow-xl rounded-2xl p-2 w-full md:w-1/3">
                <img
                  src={track.image}
                  alt={track.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
              <div className="bg-white border shadow-xl rounded-2xl p-6 w-full md:w-2/3 mt-12 md:mt-0 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-1 text-one flex items-center gap-2">
                  <Sparkle className="fill-one" />
                  {track.title}
                </h2>
                <h3 className="text-xl text-gray-600 font-semibold mb-3">
                  {track.subtitle}
                </h3>
                <p className="text-md text-gray-800 leading-relaxed">
                  {track.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default StaticTracks;




